import React, { useState } from "react";
import {
  Box,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";

import "./faq.css";

function FAQ() {
  return (
    <div id="faq-page">
      <div id="faq-top">
        <h3> Frequently Asked Questions! How can we help you? </h3>
        <div id="search-filter">
          <p> Type keywords to find answers </p>
        </div>
        <p>
          You can browse the categories below to find what you are looking for.
          We've shared some of our most frequently asked questions in each
          category to help you safely manage your period!
        </p>
      </div>

      <div id="faq-main-wrapper">
        <div id="left-filters">
          <h4>
            {" "}
            <a href="/faq"> Safely Managing Your Period </a>{" "}
          </h4>
          <h4>
            {" "}
            <a href="/faq2"> Gynecologists Recommendations </a>
          </h4>
          <h4>
            {" "}
            <a href="/faq3"> Using and Disposing Menstrual Hygiene Pads </a>
          </h4>
          <h4>
            {" "}
            <a href="/faq4"> Period Cramps </a>{" "}
          </h4>
          <h4>Sanitary Product Policies by Country </h4>
          <h4> Menstrual Hygiene Workshops </h4>
        </div>
        <div id="right-questions">
          <Accordion>
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    Should I use sanitary products that are more absorbent than
                    is needed so that I can change them less frequently?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    When should I change my pad?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
